var map = {
	"./jovemEditorDeVideo.mp4": 9060,
	"./jovemEstudando.mp4": 8770,
	"./moments_video.mp4": 6526,
	"./sonhador.mp4": 3891,
	"./valentinamoments.mp4": 2013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1342;